import React, { FC } from 'react';
import styled from 'styled-components';

type Props = {
  register: any;
  errors: any;
  name: string;
  label: string;
  required?: boolean;
  placeholder?: string;
};
const GeneralTextField: FC<Props> = ({
  register,
  errors,
  name,
  label,
  required,
  placeholder,
}) => {
  const hasError = errors[name] !== undefined;
  return (
    <FieldWrapper>
      <Label $error={hasError}>
        {label}
        {required && <Asterisk>*</Asterisk>}
      </Label>
      <Input
        type="text"
        ref={register}
        name={name}
        placeholder={placeholder}
        $error={hasError}
      />
      {hasError && (
        <ErrorMessage>{errors[name].message}</ErrorMessage>
      )}
    </FieldWrapper>
  );
};

export default GeneralTextField;

const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: inherit;
`;

const Label = styled.label<{ $error: boolean }>`
  font-size: 0.875rem;
  font-weight: 600;
  color: ${({ $error }) =>
    $error
      ? 'var(--danger-500, #dc2626)'
      : 'var(--mainText)'};
  margin-bottom: 6px;
`;

const Asterisk = styled.span`
  color: var(--danger-500, #dc2626);
  margin-left: 2px;
`;

const Input = styled.input<{ $error: boolean }>`
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border: 1px solid
    ${({ $error }) =>
      $error
        ? 'var(--danger-500, #dc2626)'
        : 'var(--border)'};
  border-radius: 8px;
  background: var(--neutral-0);
  font-family: inherit;
  font-size: 0.875rem;
  color: var(--mainText);
  box-sizing: border-box;
  transition: border-color 0.15s ease,
    box-shadow 0.15s ease;

  &::placeholder {
    color: var(--neutral-400);
  }

  &:hover {
    border-color: var(--neutral-400);
  }

  &:focus {
    outline: none;
    border-color: var(--primary-600);
    box-shadow: var(--shadow-focus);
  }

  &:disabled {
    background: var(--neutral-100);
    color: var(--neutral-500);
    cursor: not-allowed;
  }
`;

const ErrorMessage = styled.div`
  font-size: 0.75rem;
  color: var(--danger-500, #dc2626);
  margin-top: 4px;
`;
